import { classNames } from 'utils/classNames'

type Props = {
  value: string | null
  label?: string
}

export const DisplayText = (props: Props) => {
  const { label, value } = props

  const baseStyle =
    'w-full rounded border border-[#ddd] px-3 py-2 text-sm outline-none'
  const disabledStyle = 'bg-gray-50 text-gray-500'
  return (
    <div className="flex flex-col">
      {label && (
        <label className={'mb-1.5 block text-sm font-medium text-[#555]'}>
          {label}
        </label>
      )}
      <input
        value={value ?? ''}
        className={classNames([baseStyle, disabledStyle])}
        type={'text'}
        disabled={true}
      />
    </div>
  )
}
